import BaseModelFactory from './base.factory'
import UniversityLocationService from './../services/UniversityLocation.service'
import UniversityLocation from './../models/university-location.model'

class UniversityLocationFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UniversityLocationService, Model: UniversityLocation }
    )
  static findById = async id =>
    await this._findBy({ id }, { Service: UniversityLocationService, Model: UniversityLocation })
  static create = payload =>
    this._create(payload, {
      Service: UniversityLocationService,
      Model: UniversityLocation,
    })
}

export default UniversityLocationFactory
